import { Component, OnInit } from '@angular/core';
import { PortfolioService } from '../../../services/portfolio.service';
import { SubscriptionService } from '../../../../app/shared/services/subscription.service';
import { CommonService } from '../../../shared/services/common.service';


@Component({
  selector: 'app-portfolio',
  templateUrl: './portfolio.component.html',
  styleUrls: ['./portfolio.component.css']
})
export class PortfolioComponent implements OnInit {
  AuthUserObj: any = undefined;
  PossessionList:any[]=[];
  HomeList:any[]=[];
  CommunityList:any[]=[];
  //IsCobuyer : any=false;
  constructor(public portfolioService:PortfolioService,public subscriptionService:SubscriptionService,public commonService: CommonService) { 
    this.AuthUserObj = commonService.AuthUser.getValue();
  }

  ngOnInit() {
    //
    // if (this.AuthUserObj && this.AuthUserObj.BuyerID > 0) {
    //   console.log(this.AuthUserObj.IsCobuyer);
    //   this.IsCobuyer = this.AuthUserObj.IsCobuyer;
    // }
  }

  

}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/portfolio/portfolio.component.ts